module.exports = __webpack_public_path__ + "static/media/cheese-swiss.bbb2ae84.svg";